/**
 *
 */
import { ClientComponentLogger, LogErrorParams } from './client-component-logger';
import {
    trackAddToEvent,
    trackEvent,
    trackView,
    trackViewFeatures,
    trackAddActionToEvent,
    trackOnNextPageImpression,
    getGlobalEventMergeId,
} from './_common/client/tracking';
import { NamedTrackingFeatures, TrackingFeatures } from './tracking/client/event-data-types';
import { ActionName, DataContainer } from '@otto-ec/tracking-bct';

export abstract class BaseComponent {
    public abstract rootSelector: string;

    /**
 *
 */
    protected logger?: ClientComponentLogger;

    /**
 *
 */
    public async init(): Promise<unknown> {
        return;
    }

    /**
 *
 */
    public async onHtmlLoaded(): Promise<unknown> {
        return;
    }

    /**
 *
 */
    public async setLogger(logger: ClientComponentLogger) {
        this.logger = logger;
    }

    /**
 *
 *
 */
    protected trackEvent(data: Record<string, unknown>): void {
        trackEvent(data);
    }

    protected trackOnNextPageImpression(data: DataContainer): void {
        trackOnNextPageImpression(data);
    }

    /**
 *
 *
 *
 */
    protected trackAddToEvent(data: Record<string, unknown>, actionName: ActionName, eventMergeId: string): void {
        trackAddToEvent(data, actionName, eventMergeId);
    }

    /**
 *
 *
 *
 */
    protected trackAddActionToEvent(data: NamedTrackingFeatures, eventMergeId: string) {
        trackAddActionToEvent(data, eventMergeId);
    }

    /**
 *
 *
 */
    protected trackView(data: Record<string, unknown>): void {
        trackView(data);
    }

    /**
 *
 *
 */
    protected trackViewFeatures(data: TrackingFeatures): void {
        if (o_product.state.isVariationChanged) {
            const eventMergeId = getGlobalEventMergeId();
            if (eventMergeId === undefined) {
                throw new Error('No global event merge id is set after variation change, cannot merge action onto variation change event');
            }
            trackAddActionToEvent({ name: 'change', features: data }, eventMergeId);
        } else {
            trackViewFeatures(data);
        }
    }

    /**
 *
 *
 *
 *
 */
    protected notNullQuerySelector<T extends Element = HTMLElement>(selectors: string, parent: ParentNode = document): T {
        const element = parent.querySelector<T>(selectors);

        if (!element) {
            throw new Error(`can not select '${selectors}'`);
        }

        return element;
    }

    /**
 *
 */
    protected getRootElement<T extends HTMLElement>(): T {
        return this.notNullQuerySelector(this.rootSelector);
    }

    /**
 *
 *
 */
    protected getVariationId(): string {
        return this.getRootElement().getAttribute('data-variation-id') || '';
    }

    /**
 *
 *
 */
    protected getChildElement<T extends HTMLElement>(selectors: string): T {
        return this.notNullQuerySelector(selectors, this.getRootElement());
    }

    /**
 *
 *
 */
    protected getChildElements<T extends HTMLElement>(selectors: string): T[] {
        return Array.from(this.getRootElement().querySelectorAll(selectors));
    }

    /**
 *
 */
    protected isPresent(): boolean {
        return !!document.querySelector(this.rootSelector);
    }

    /**
 *
 */
    protected hide() {
        this.getRootElement().classList.add('oc-visually-hidden');
    }

    /**
 *
 */
    protected show() {
        this.getRootElement().classList.remove('oc-visually-hidden');
    }

    /**
 *
 *
 *
 */
    protected logError(params: LogErrorParams) {
        !this.logger ? console.error(params) : this.logger.logError(params);
    }
}
